import { UserModel } from '../api/authentication/authentication.types';

export function userCanAccessComponent(user: UserModel, permittedRoles?: string[]) {
  let matchingRoleFound = false;

  if (!permittedRoles) {
    return true;
  }

  permittedRoles.forEach((role) => {
    if (user.roles.includes(role)) {
      matchingRoleFound = true;
    }
  });

  return matchingRoleFound;
}
